import styled from "styled-components"

export const Container = styled.button`
   display: flex;
   width: 100%;
   height: 48px;
   border-radius: 8px;
   border: none;
   justify-content: center;
   font-size: 16px;
   line-height: 24px;
   align-items: center;
   cursor: pointer;
   transition: all .3s;
   
   &:disabled {
       background: ${({theme}) => theme.colors.disabledBg};
       border-color: ${({theme}) => theme.colors.disabledBg};
       color: ${({theme}) => theme.colors.disabledText};
       cursor: not-allowed;
       opacity: 1;
       transform: none;
   }
   
   &:hover:not(:disabled) {
          transform: scale(1.05);
     }
     &.access {
          background: ${({theme}) => theme.colors.primaryRed400};
          color: ${({theme}) => theme.colors.pureWhite};
     }
     &.cancel {
          border: 2px solid ${({theme}) => theme.colors.interfaceText400};
          background: ${({ theme }) => theme.colors.interfacePure0};
          color: ${({theme}) => theme.colors.interfaceText400};
     }
     &.continue {
          background: ${({theme}) => theme.colors.primaryRed400};
          color: ${({theme}) => theme.colors.pureWhite};
     }
     &.danger {
          background: ${({theme}) => theme.colors.interfaceDanger400};
          color: ${({theme}) => theme.colors.pureWhite};
     }
     &.save {
          background: ${({theme}) => theme.colors.interfaceTextGray};
          color: ${({theme}) => theme.colors.pureWhite};
     }
`